export class CPPReturnsLandingFilterVM {
  productLineId: any;
  productName: string;
  itemNo: string;
  accountName: string;
  account: string;
  soldTo: string;
  fromOrderDate: any;
  toOrderDate: any;
  returnRequestNumber: string;
  processingStatus: string;
  notification: string;
  productLineFilter: any;
  customerPO: string;
  branchPlant: string;
}
